<div class="materials-items-wrapper" fxLayout="column" *ngIf="items$ | async; let items; else: loading">
    <div fxLayout="row" fxLayoutAlign="space-between center" *ngFor="let item of items">
        <div fxLayoutAlign="start center" fxLayoutGap="10px">
            <mat-icon class="dark-blue-color">business_center</mat-icon>
            <span class="dark-blue-color"> {{ item.title }}</span>
        </div>
        <div class="info-wrap" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px">
            <div fxLayoutAlign="start center" fxLayoutGap="5px">
                <span class="dark-blue-color" i18n="@@StartedAt">Started at</span>:
                <span *ngIf="item.item_opportunity_started_at" class="ml-5">{{
                    item.item_opportunity_started_at | kdDateFormat : 'YYYY-MM-DD HH:mm'
                }}</span>
                <span *ngIf="!item.item_opportunity_started_at" class="ml-5" i18n>N/A</span>
            </div>
            <div fxLayoutAlign="start center" fxLayoutGap="5px">
                <span class="dark-blue-color" i18n="@@DoneAt">Done at</span>:
                <span *ngIf="item.item_opportunity_done" class="ml-5">{{
                    item.item_opportunity_done | kdDateFormat : 'YYYY-MM-DD HH:mm'
                }}</span>
                <span *ngIf="!item.item_opportunity_done" class="ml-5" i18n>N/A</span>
            </div>
            <button
                [ngClass]="{ 'mand-item': item.mandatory }"
                class="repeat-item"
                (click)="$event.stopPropagation(); repeatItem(item)"
                matTooltip="Study again. No records of your practice will be displayed in the course"
                mat-icon-button
                i18n-matTooltip
            >
                <mat-icon>play_circle_outline</mat-icon>
            </button>
        </div>
    </div>
</div>
<ng-template #loading>
    <div class="mt-2" fxLayout="row" fxLayoutAlign="center center">
        <app-kd-logo-loading></app-kd-logo-loading>
    </div>
</ng-template>
